const REPOSITORIES_BASE = "/search/repositories";
const REPOSITORIES_DETAIL_BASE = "/repos";

export const repositoriesApiConstants = {
  REPOSITORIES_LIST: REPOSITORIES_BASE,
  REPOSITORIES_DETAIL_BASE: REPOSITORIES_DETAIL_BASE,
};
